export const showTooltip = async (key: number, setCopied: (value?: number) => void) => {
  setCopied(key)

  setTimeout(() => {
    setCopied()
  }, 1500)
}
